import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { checkStatus,getMonthTHFromInt } from '../../../../util/util';
import AlertBar from '../../../Modals/AlertBar';
import ModalConfirmDelete from '../../../Modals/ModalConfirmDelete';
import {AlertConfirm, AlertCommit} from '../../../Modals/AlertBar';

class DeviceAlert extends Component {

    constructor(props) {
        super(props);

        this.state = {
            
            alert_type: '',
            alert_when: '',
            alert_channel: {
                email: '',
                line: ''
            },
            alertList:[],
            addAlert:false,
            is_email:false,
            is_line:false,
            alert:'',
            alertTo:'',
            notification:false,
            editAlert:false,
            alertId:0,
            ShowDeleteRow:false,
            alertTypeList:[],
            openAlertWhen:false,
            alertType:'',
            alertWhen:'',
            alertTypeId: '',
            alertGroup: '',
            alertWhenList:[],
            alertWhenName:'',
            alert_last_dtm:null,
            is_alert:'',
        }
    }
    
    componentWillReceiveProps(nextProps) {

        if (nextProps.alert !== this.props.alert ) {

            let alertList = nextProps.alert;
            this.setState({
                alertList: alertList,
            });
        }
    }

    componentDidMount(){
        // console.log('componentDidMount');
        this.getAlertTypeList();
        
    }
    componentWillUnmount(){
        
    }

    addAlert = () =>{
        this.setState({
           
            alertType:'',
            alertWhen:'',
            alertTypeId: '',
            alertGroup: '',
            alertWhenList:[],
            alertWhenName:'',
            is_email:false,
            is_line:false,
            addAlert:true,
            openAlertWhen:false,
        });
    }
    
    onAddAlertClose = () =>{
        this.setState({
            addAlert:false,
            editAlert:false
        })
    }

    handleChangeCheckboxEmail = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
    
        this.setState({
          is_email: value
        });
    }

    handleChangeCheckboxLine = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
    
        this.setState({
          is_line: value
        });
      }

      getAlertTypeList(){

        const {
            is_email,
            is_line,
            alert,
            alertTo,} = this.state;

        const { user_id, user_name,token,deviceId ,getDeviceInfo} = this.props;

        fetch(`http://203.150.199.244/api/admin/getAlertTypeList`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({
            })
            })
            .then(response => { return checkStatus(response)})
            .then((data) => { this.setAlertTypeList(data.RESULT_DATA);
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
            
      }

      setAlertTypeList(alertTypeList){

        // let arr = [];
        // alertTypeList.map((alertType) => {

        //     arr.push({
        //         "id":alertType.alert_type_id,
        //         "gorup":alertType.alert_group,
        //         "type":alertType.alert_type
        //     })
        // })
        
        this.setState({alertTypeList: alertTypeList});
      }

      onAddAlert = () => {

        const {
            is_email,
            is_line,
            alert,
            alertTo,alertId,alertType,
            alertWhen,
            alertTypeId,
            alertGroup,} = this.state;

        const { user_id, user_name,token,deviceId ,getDeviceInfo} = this.props;

        if(alertGroup == ''){
            return 0;
        }else{

            // if((alertGroup == 'POI' || alertGroup == 'STATE') && alertWhen == ''){
            //     return 0;
            // }else{
                
                fetch(`http://203.150.199.244/api/admin/addDeviceAlert/${deviceId}`, {
                method: 'post',
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    // "user_id": user_id,
                    // "user_name": user_name,
                    "token": token
                },
                body: JSON.stringify({

                        "alert_when": alertWhen,
                        "alert_group":alertGroup,
                        "alert_type_id":alertTypeId,
                        "alert_channel": {
                            "email": is_email,
                            "line": is_line
                        }
                        
                })
                })
                .then(response => { return checkStatus(response)})
                .then((data) => {
                    
                    if(data.RESULT_STATUS == "000")
                        AlertCommit(true,"บันทึกข้อมูลเรียบร้อยแล้ว");
                    else{
                            AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                    }

                    this.setState({
                        addAlert:false,
                        // notification: true,
                    }, () => getDeviceInfo());

                })
                .catch(function (err) {
                    console.log('err:', err);
                    // POST failed...
                });
            // }

        }
        
            
      }

      editAlert(alert){

        if(alert.alert_group == 'POI' || alert.alert_group == 'STATE'){

            let when = '';
            let list = [];
            if(alert.alert_group == 'POI'){

                if(alert.alert_when == 'I'){
                    when = 'เข้าสู่';
                }
                if(alert.alert_when == 'O'){
                    when = 'ออกจาก';
                }
                list = [{"alert_when": "I","name":"เข้าสู่"},{"alert_when": "O","name":"ออกจาก"}];
            }
            if(alert.alert_group == 'STATE'){

                if(alert.alert_when == '1'){
                    when = 'ติดเครื่อง';
                }
                if(alert.alert_when == '0'){
                    when = 'ดับเครื่อง';
                }
                list = [{"alert_when": 1,"name":"ติดเครื่อง"},{"alert_when": 0,"name":"ดับเครื่อง"}]
            }

            this.setState({
                editAlert:true,
                alertType: alert.alert_type,
                alertWhenName: when,
                alertWhen: alert.alert_when,
                alertGroup: alert.alert_group,
                is_email:alert.alert_channel.email,
                is_line:alert.alert_channel.line,
                alertId:alert.alert_id,
                alertTypeId:alert.alert_type_id,
                openAlertWhen:true,
                alertWhenList:list,
            });
        }else{
            this.setState({
                editAlert:true,
                alertType: alert.alert_type,
                alertWhen: '',
                alertGroup: alert.alert_group,
                is_email:alert.alert_channel.email,
                is_line:alert.alert_channel.line,
                alertId:alert.alert_id,
                alertTypeId:alert.alert_type_id,
                openAlertWhen:false,
            });
        }
        
      }

      onEditAlert = () => {

        const {
            is_email,
            is_line,
            alert,
            alertTo,alertId,alertType,
            alertWhen,
            alertTypeId,
            alertGroup,} = this.state;

        const { user_id, user_name,token,deviceId ,getDeviceInfo} = this.props;
        
        
            if(alertGroup != 'POI' && alertGroup != 'STATE'){
                this.state.alertWhen = '';
            }


        fetch(`http://203.150.199.244/api/admin/updateDeviceAlert/${deviceId}/${alertId}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({
                "alert_when": alertWhen,
                "alert_group":alertGroup,
                "alert_type_id":alertTypeId,
                "alert_channel": {
                    "email": is_email,
                    "line": is_line
                }
            })
            })
            .then(response => { return checkStatus(response)})
            .then((data) => {
                
                if(data.RESULT_STATUS == "000")
                    AlertCommit(true,"แก้ไขข้อมูลเรียบร้อยแล้ว");
                else{
                        AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                }

                this.setState({
                    editAlert:false,
                    // notification: true,
                }, () => getDeviceInfo());

            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
            
      }

      onClickCancelDelete = (status) => {
        this.setState({ ShowDeleteRow: status });
    }

    deleteDevice = (alertId) => {

        AlertConfirm("ลบการแจ้งเตือน").then(isOk=>{
            if(isOk){
                const { user_id, user_name,token,deviceId ,getDeviceInfo} = this.props;

                fetch(`http://203.150.199.244/api/admin/deleteDeviceAlert/${deviceId}/${alertId}`, {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        // "user_id": user_id,
                        // "user_name": user_name,
                        "token": token
                    },
                    body: JSON.stringify({
                    })
                    })
                    .then(response => { return checkStatus(response)})
                    .then((data) => {
                        
                        if(data.RESULT_STATUS == "000")
                            AlertCommit(true,"ลบข้อมูลเรียบร้อยแล้ว");
                        else{
                            AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                        }

                        this.setState({
                            ShowDeleteRow:false,
                            // notification: true,
                        }, () => getDeviceInfo());

                    })
                    .catch(function (err) {
                        console.log('err:', err);
                        // POST failed...
                    });
            }
            
        });

        
    }

    // deleteDevice(alertId){
    //     this.setState({
    //         alertId:alertId,
    //         // ShowDeleteRow: true,
    //     }) 
    // }

    changeAlertType = (event) => {
        
        this.setState({
            alertType:'',
            alertId:0,
            alertGroup:'',
            openAlertWhen:false,
            alertTypeId:'',
        });

        let e= event.target.value;
        // let val = e.split(",");
        // let type = val[2];
        // let group = val[1];
        // let id = val[0];

        let array = [...this.state.alertTypeList]; 
        let index = array.find(item => item.alert_type == e);
        let type = index.alert_type;
        let group = index.alert_group;
        let typeId = index.alert_type_id;
        let id = this.state.alertId;
        if(group === 'POI'){
            let list = [{"alert_when": "I","name":"เข้าสู่"},{"alert_when": "O","name":"ออกจาก"}];
            this.setState({alertId:id,alertTypeId:typeId, alertGroup:group,alertType:type, openAlertWhen:true,alertWhenList:list});

        }
        else if(group === 'STATE'){
            let list = [{"alert_when": 1,"name":"ติดเครื่อง"},{"alert_when": 0,"name":"ดับเครื่อง"}]
            this.setState({alertId:id,alertTypeId:typeId, alertGroup:group,alertType:type,openAlertWhen:true,alertWhenList:list});
        }
        else{
            this.setState({
                alertWhen:'',
                alertType:type,
                alertId:id,
                alertGroup:group,
                openAlertWhen:false,
                alertTypeId:typeId,
            });
        }

        

     }

     changeAlertWhen = (event) => {
        
        let e = event.target.value;

        let array = [...this.state.alertWhenList]; 
        let index = array.find(item => item.name == e);
        let when = index.alert_when;
        let name = index.name;
        this.setState({alertWhen:when,alertWhenName:name});
        

     }

     convertDateFormat(date){
        let dateString = date.substring(0,10);
        let str = dateString.split("-");
        let year = parseInt(str[2])+543;
        let month = getMonthTHFromInt(parseInt(str[1]));
        return str[0]+' '+month.toString()+' '+year.toString();
    }

    render(){
       
        const {  
            alert_type,
            alert_when,
            alert_channel,
            alertList,
            addAlert,
            is_email,
            is_line,
            alert,
            alertTo,
            notification,
            editAlert,
            ShowDeleteRow,
            alertTypeList,
            openAlertWhen,
            alertWhenList,
            alertType,
            alertWhen,
            alertTypeId,
            alertGroup,
            alertWhenName,alertId
        } = this.state;
        
        
        return(
        
            <div className="container-fluid">
            { addAlert &&
                   <div className="modal-confirm" style={{display:'block'}} >
                   <div className="modal-dialog modal-dialog-centered modal-lg">
                       <div className="modal-content">
                           <div className="modal-header">
                               <h6 className="modal-title custom_align" id="Heading">เพิ่มการแจ้งเตือน</h6>
                           </div>
   
                           <div className="modal-body">
                                <div className="form-group row">
                                    <label htmlFor="example-text-input " className="col-md-3 " >แจ้งเตือน</label>
                                    <div className="col-md-9">
                                        {/* <input
                                            className="form-control"
                                            type="text"
                                            id="name"
                                            defaultValue={alert}
                                            onChange={(e) => this.setState({ alert: e.target.value })}

                                        /> */}

                                        <select class="form-control" value={alertType}
                                            onChange={this.changeAlertType}>
                                            <option value="select">เลือกการแจ้งเตือน</option>
                                            {
                                            alertTypeList.map((item,key) => {
                                                return(
                                                    <option selected={alertType == item.alert_type} value={item.alert_type}>{item.alert_type}</option> 
                                                )
                                            })
                                            }
                                        </select>
                                    </div>
                                </div>
                                {openAlertWhen &&

                                    <div className="form-group row">
                                    <label htmlFor="example-text-input" className="col-md-3 " >เมื่อเป็น</label>
                                    <div className="col-md-9">
                                        {/* <input
                                            className="form-control"
                                            type="text"
                                            id="name"
                                            value={alertTo}
                                            onChange={(e) => this.setState({alertTo : e.target.value })}
                                        /> */}
                                        <select class="form-control" value={alertWhenName} 
                                            onChange={this.changeAlertWhen}>
                                            <option value="select">เลือกการแจ้งเตือน</option>
                                            {
                                                alertWhenList.map((item,key) => {

                                                return(
                                                    <option selected={alertWhenName == item.name} value={item.name}>{item.name}</option> 
                                                )
                                            })
                                            }
                                        </select>
                                    </div>
                                    </div>
                                }
                                <div className="form-group row">
                                    <label htmlFor="example-text-input" className="col-md-3 " >เตือนทาง</label>
                                    <div className="col-md-3">
                                    
                                        <label>
                                            <input
                                            type="checkbox"
                                            checked={is_email}
                                            onChange={this.handleChangeCheckboxEmail} 
                                            style={{marginRight:3}}
                                            />
                                            E-Mail
                                        </label>
                                    
                                    </div>
                                    <div className="col-md-3">
                                    
                                        <label>
                                            
                                            <input
                                            type="checkbox"
                                            checked={is_line}
                                            onChange={this.handleChangeCheckboxLine} 
                                            style={{marginRight:3}}
                                            />
                                            Line 
                                        </label>
                                    
                                    </div>
                                </div>
                           </div>
   
                           <div className="modal-footer ">
                               <button className="btn btn-primary" onClick={this.onAddAlert} >บันทึก</button>
                               <button className="btn btn-danger" onClick={this.onAddAlertClose} >ยกเลิก</button>
                           </div>
                       </div>
                   
                   </div>
               </div>
               }
 
               { editAlert &&
                   <div className="modal-confirm" style={{display:'block'}} >
                   <div className="modal-dialog modal-dialog-centered">
                       <div className="modal-content">
                           <div className="modal-header">
                               <h6 className="modal-title custom_align" id="Heading">แก้ไขการแจ้งเตือน</h6>
                           </div>
   
                           <div className="modal-body">
                                <div className="form-group row">
                                    <label htmlFor="example-text-input " className="col-md-3 " >แจ้งเตือน</label>
                                    <div className="col-md-9">
                                        {/* <input
                                            className="form-control"
                                            type="text"
                                            id="name"
                                            defaultValue={alert}
                                            onChange={(e) => this.setState({ alert: e.target.value })}

                                        /> */}

                                        <select class="form-control" value={alertType}
                                            onChange={this.changeAlertType}>
                                            <option value="select">เลือกการแจ้งเตือน</option>
                                            {
                                            alertTypeList.map((item,key) => {
                                                return(
                                                    <option selected={alertType == item.alert_type} value={item.alert_type}>{item.alert_type}</option> 
                                                )
                                            })
                                            }
                                        </select>
                                    </div>
                                </div>
                                {openAlertWhen &&

                                    <div className="form-group row">
                                    <label htmlFor="example-text-input" className="col-md-3 " >เมื่อเป็น</label>
                                    <div className="col-md-9">
                                        {/* <input
                                            className="form-control"
                                            type="text"
                                            id="name"
                                            value={alertTo}
                                            onChange={(e) => this.setState({alertTo : e.target.value })}
                                        /> */}
                                        <select class="form-control" value={alertWhenName} 
                                            onChange={this.changeAlertWhen}>
                                            <option value="select">เลือกการแจ้งเตือน</option>
                                            {
                                                alertWhenList.map((item,key) => {

                                                return(
                                                    <option selected={alertWhenName == item.name} value={item.name}>{item.name}</option> 
                                                )
                                            })
                                            }
                                        </select>
                                    </div>
                                    </div>
                                }
                                <div className="form-group row">
                                    <label htmlFor="example-text-input" className="col-md-3 " >เตือนทาง</label>
                                    <div className="col-md-3">
                                    
                                        <label>
                                            <input
                                            type="checkbox"
                                            checked={is_email}
                                            onChange={this.handleChangeCheckboxEmail} 
                                            style={{marginRight:3}}
                                            />
                                            E-Mail
                                        </label>
                                    
                                    </div>
                                    <div className="col-md-3">
                                    
                                        <label>
                                            
                                            <input
                                            type="checkbox"
                                            checked={is_line}
                                            onChange={this.handleChangeCheckboxLine} 
                                            style={{marginRight:3}}
                                            />
                                            Line 
                                        </label>
                                    
                                    </div>
                                </div>
                           </div>
   
                           <div className="modal-footer ">
                               <button className="btn btn-primary" onClick={this.onEditAlert} >บันทึก</button>
                               <button className="btn btn-danger" onClick={this.onAddAlertClose} >ยกเลิก</button>
                           </div>
                       </div>
                   
                   </div>
               </div>
               }
            <div className="card">
                    <h6 class="card-header">แจ้งเตือน</h6>
                    { notification &&
                    <AlertBar status={this.state.statusAlert}/>
                    }
                    {/* { ShowDeleteRow &&
                        <ModalConfirmDelete
                            onClickCancelDelete={this.onClickCancelDelete}
                            onClickConfirmDelete={this.onClickConfirmDelete}
                        />
                    } */}
                    <div class="card-body">
                        <div className="col-md-12 table-responsive">
                        <div style={{textAlign:'right'}}>
                        <button className="btn btn-info btn-xs" data-title="Add" data-toggle="modal" onClick={this.addAlert} ><span className="fa fa-plus" /></button>
                        </div>
                        
                            <table  className="table table-bordred table-striped table-hover ">
                            
                                <thead >
                                    <tr>
                                        <th rowSpan='2'>#</th>
                                        <th rowSpan='2' style={{minWidth:120}}>เตือน</th>
                                        <th rowSpan='2' style={{minWidth:120}}>เมื่อเปลี่ยนเป็น</th>
                                        <th colSpan='2' style={{minWidth:120}} className="text-center">เตือนทาง</th>
                                        <th rowSpan='2' style={{minWidth:120}} className="text-center">ส่งแล้ว</th>
                                        <th rowSpan='2' style={{minWidth:120}}>เตือนล่าสุด</th>
                                        <th rowSpan='2' style={{width:'20px'}}></th>
                                        <th rowSpan='2'style={{width:'20px'}}></th>
                                    </tr>
                                    <tr>
                                        <th className="text-center">E-Mail</th>
                                        <th className="text-center">Line</th>
                                        
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                }
                                {
                                    

                                    alertList.map((alert,key) => {

                                        return(
                                            <tr key={key}>
                                                <td>{key+1}</td>
                                                <td>{alert.alert_type}</td>
                                                {
                                                    alert.alert_group == 'POI' && alert.alert_when == 'I' &&
                                                    <td>เข้าสู่</td>
                                                }
                                                {
                                                    alert.alert_group == 'POI' && alert.alert_when == 'O' &&
                                                    <td>ออกจาก</td>
                                                }
                                                {
                                                    alert.alert_group == 'STATE' && alert.alert_when == '1' &&
                                                    <td>ติดเครื่อง</td>
                                                }
                                                {
                                                    alert.alert_group == 'STATE' && alert.alert_when == '0' &&
                                                    <td>ดับเครื่อง</td>
                                                }
                                                {
                                                    alert.alert_group != 'STATE' && alert.alert_group != 'POI' && 
                                                    <td></td>
                                                }
                                                <td style={{textAlign:'center'}}>
                                                {alert.alert_channel.email && 
                                                    <i class="fa fa-check" aria-hidden="true"></i>
                                                }
                                                </td>
                                                <td style={{textAlign:'center'}}>
                                                {alert.alert_channel.line && 
                                                    <i class="fa fa-check" aria-hidden="true"></i>
                                                }
                                                </td>
                                                <td style={{textAlign:'center'}}>
                                                { alert.is_alert && 
                                                 <i class="fa fa-check" aria-hidden="true"></i> 
                                                }
                                                </td>
                                                <td>{alert.alert_last_dtm  ? this.convertDateFormat(alert.alert_last_dtm ) : alert.alert_last_dtm }</td>
                                                <td style={{textAlign:'right'}}><p data-placement="top" data-toggle="tooltip" title="Edit">
                                                    <button  className="btn btn-primary btn-xs"
                                                    data-backdrop="static" data-keyboard="false" onClick={() => this.editAlert(alert)}><span className="fa fa-pencil" />
                                                    </button></p>
                                                </td>
                                                <td style={{textAlign:'right'}}><p data-placement="top" data-toggle="tooltip" title="Delete">
                                                    <button className="btn btn-danger btn-xs" data-title="Delete" onClick={() => {this.deleteDevice(alert.alert_id)}}>
                                                    <span className="fa fa-trash" />
                                                    </button>
                                                    </p>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                                </tbody>
                            </table>
                        </div> 
                         
                    </div>
                </div>
                
               
            </div>
            
        );
    }
}


DeviceAlert.defaultProps = {
    alert: []
}

DeviceAlert.PropTypes = {
    alert: PropTypes.object,
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired,
    deviceId: PropTypes.number.isRequired,
    getDeviceInfo:PropTypes.func.isRequired,
}

export default DeviceAlert;


// WEBPACK FOOTER //
// ./src/app/view/components/AdminConfig/Content/DeviceAlert.js